const DEFAULT_SELECT_CLASSES = [
  'w-full',
  'p-1',
  'text-gray-900',
  'border',
  'border-gray-300',
  'rounded-lg',
  'focus:border-blue-500'
].join(' ');

export type SelectMenuOption = { value: string; text: string; disabled?: boolean };

export interface SelectMenuProps {
  id?: string;
  ariaLabel?: string;
  defaultValue?: string;
  value?: string;
  handleSelect: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  name: string;
  options: SelectMenuOption[];
  selectClasses?: string;
  handleClick?: (e: React.SyntheticEvent) => void;
  handleFocus?: (e: React.SyntheticEvent) => void;
  handleBlur?: (e: React.SyntheticEvent) => void;
  dataCy?: string;
}

export const SelectMenu = ({
  id,
  ariaLabel,
  name,
  options,
  handleSelect,
  defaultValue,
  value,
  selectClasses,
  handleClick,
  handleBlur,
  handleFocus,
  dataCy
}: SelectMenuProps) => {
  return (
    <select
      id={id}
      aria-label={ariaLabel}
      name={name}
      className={`${DEFAULT_SELECT_CLASSES}  ${selectClasses}`}
      data-cy={dataCy}
      onClick={handleClick}
      {...(value !== undefined ? { value } : { defaultValue })}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onChange={handleSelect}>
      {options.map(({ value: optVal, text, disabled }) => (
        <option
          key={optVal}
          value={optVal}
          disabled={disabled}>
          {text}
        </option>
      ))}
    </select>
  );
};
